import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

export const useTitleTranslation = (basePath?: string, omitRootTitle = false) => {
  const [t] = useTranslation('titles');
  const location = useLocation();
  const previousTitleRef = useRef<string>(document.title);

  useEffect(() => {
    const basicPathSegments = basePath?.split("/").filter(Boolean) || [];
    const allPathSegments = [...basicPathSegments, ...location.pathname
                                                              .split("/")
                                                              .filter(Boolean)];

    const titleParts: string[] = [];

    for (let i = allPathSegments.length; i > 0; i--) {
      const key = allPathSegments.slice(0, i).join(".");
      const translatedTitle = t(`${key}.title`, { defaultValue: "" });
      if (translatedTitle) {
        titleParts.push(translatedTitle);
      }
    }
    !omitRootTitle && titleParts.push(t("title"));
    const titleCandidate = titleParts.join(" | ");
    if (titleCandidate !== previousTitleRef.current) {
      document.title = titleCandidate;
      previousTitleRef.current = titleCandidate;
    }
  }, [location, t]);
};